import module from 'guest/module.js'
import moment from 'moment'

const schema = {}

class GuestNominasService {
  constructor ($http) {
    this.$http = $http
  }

  get (idProyecto, idColaborador, fechaInicial, fechaFinal, idMoneda) {
    const hoy = new Date()

    return this.$http.get('/kendu/kardex/nominas', {
        params: {
          idEmpresa: idProyecto,
          idEmpleado: idColaborador,
          inicio: fechaInicial.toYMD(),
          fin: fechaFinal.toYMD(),
          moneda: idMoneda,
        },
        schema,
      })
      .then((response) => {
        return response.data.map((item) => {
          let fecha = new Date(item['Fecha_Pago'])
          let formato = hoy.getFullYear() === fecha.getFullYear() ? 'MMMM D' : 'MMMM D, YYYY'

          return {
            Agrupacion: moment(fecha).format(formato).toUpperCase(),
            Moneda: item.Moneda,
            Codigo: item.Codigo_Movimiento,
            Fecha_Pago: new Date(item.Fecha_Pago),
            ID_Nomina: item.ID_Nomina,
            Notas: item.Notas,
            Fecha_Inicial: item.Fecha_Inicial,
            Fecha_Final: item.Fecha_Final,
            Importe: item.Importe,
            Comision: item.Comision,
            Deducciones: item.Deducciones,
            Neto: item.Neto,
            Documentos: {
              Documento_Comprobante_Deposito: item.Documento_Comprobante_Deposito || false,
              Documento_Estado_Cuenta: !!item.Documento_Estado_Cuenta,
              Documento_Tirilla: item.Documento_Tirilla || false,
              Documento_XML: !!item.Documento_XML,
            },
          }
        })
      })
  }
}

module.service('GuestNominas', GuestNominasService)



// WEBPACK FOOTER //
// ./src/guest/services/Guest/Nominas.js